import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import LanguageSwitch from "@/components/LanguageSwitch";
import Logo from "@/components/Logo";

export default function Header() {
  const loc = useLocation();
  const navigate = useNavigate();
  const isHome = loc.pathname === "/";
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) return null;

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 backdrop-blur-xl bg-ivory-50/90 border-b border-ink-200/30"
    >
      <div className="flex items-center justify-between px-5 pt-safe py-3">
        <div className="flex items-center gap-2 min-w-0">
          {!isHome && (
            <button
              onClick={() => navigate(-1)}
              data-testid="header-back"
              aria-label="Back"
              className="w-9 h-9 -ml-1 flex items-center justify-center rounded-full text-ink-700 hover:bg-ivory-200 active:scale-95 transition"
            >
              <ChevronLeft strokeWidth={1.6} className="w-5 h-5" />
            </button>
          )}
          <Link
            to="/"
            data-testid="header-logo"
            aria-label="La Piazzetta — Home"
            className="flex items-center min-w-0"
          >
            <Logo variant="mark" className="w-9 h-9" />
          </Link>
        </div>
        <LanguageSwitch />
      </div>
    </header>
  );
}
